<template>
    <div class="flex items-start md:items-center justify-center w-full min-h-full p-10 lg:p-20">
        <slot />
    </div>
</template>
